<template>
  <v-select
    :items="registration.activities"
    :item-text="itemText"
    :value="value"
    @input="$emit('input', $event)"
    item-value="_id"
    v-bind="$attrs"
  />
</template>

<script>
import gql from 'graphql-tag'
import { get } from 'lodash'

export default {
  name: 'RegistrationActivitySelect',

  props: {
    value: {
      type: String
    },
    registrationId: {
      type: String,
      required: true
    }
  },

  data: () => ({
    registration: {
      activities: []
    }
  }),

  computed: {
    memberTypeMap () {
      const entries = this.memberTypes.map(o => [o.value, {
        ...o,
        subTypeMap: Object.fromEntries((o.subTypes ?? []).map(o => [o.value, o]))
      }])
      return Object.fromEntries(entries)
    }
  },

  apollo: {
    registration: {
      query: gql`query GetRegistrationBrands($id: MongoID!) {
        registration: registrationById(_id: $id) {
          _id
          activities {
            _id
            type
            subType
            from
            to
          }
        }
      }`,
      variables () {
        return {
          id: this.registrationId
        }
      },
      error (e) { this.$emit('error', e) }
    },

    memberTypes: {
      query: gql`query AllMemberTypes {
        memberTypes: memberTypeMany {
          _id
          name
          value
          subTypes {
            _id
            name
            value
          }
        }
      }`,
      error (e) { this.$emit('error', e) }
    }
  },

  methods: {
    itemText (activity) {
      const memberType = get(this.memberTypeMap, [activity.type, 'name'], activity.type)
      const subType = get(this.memberTypeMap, [activity.type, 'subTypeMap', activity.subType, 'name'], activity.subType)
      let str = memberType
      if (subType) str += ` - ${subType}`
      if (activity.from) str += `, ${activity.from}`
      if (activity.to) str += ` to ${activity.to}`
      return str
    }
  }
}
</script>
